import { useTranslation } from "react-i18next";

const BottomBanner = ({ image, imageSmall, title, shadow = false }) => {
  const { t } = useTranslation();

  const renderTextBlock = (bgColor, sizeClasses) => (
    <div
      className={`text-center text-white font-bold uppercase tracking-wider w-full sm:w-[80%] lg:w-[50%] ${sizeClasses}`}
      style={{ backgroundColor: bgColor }}
    >
      <p className="text-2xl sm:text-3xl lg:text-5xl font-bold italic leading-tight">
        “{title}”
      </p>
      <a
        href="https://wa.me/992987911110"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-7 inline-flex items-center border border-white px-10 py-3 text-sm font-semibold tracking-widest uppercase text-white cursor-pointer hover:text-[#223746] hover:bg-white transition-colors duration-200"
      >
        {t("common.inquire")}
      </a>
    </div>
  );

  return (
    <div className="mt-5">
      <div className="relative overflow-hidden">
        {imageSmall ? (
          <img
            src={imageSmall}
            alt=""
            className="block md:hidden w-full h-auto"
          />
        ) : (
          <div
            className="md:hidden w-full h-[480px] bg-cover bg-center"
            style={{ backgroundImage: `url(${image})` }}
          />
        )}

        <div
          className="hidden md:block w-full h-[640px] lg:h-[900px] bg-cover bg-center md:bg-fixed"
          style={{ backgroundImage: `url(${image})` }}
        />

        {shadow && <div className="absolute inset-0 bg-black/60" />}

        <div className="hidden md:flex absolute inset-x-0 md:top-60 lg:top-80 justify-center px-4 sm:px-6">
          {renderTextBlock(
            "",
            "text-2xl sm:text-4xl lg:text-5xl p-6 sm:p-8 lg:p-10",
          )}
        </div>
      </div>

      <div className="md:hidden flex justify-center">
        {renderTextBlock("rgba(40, 19, 19, 0.8)", "text-xl p-10")}
      </div>
    </div>
  );
};

export default BottomBanner;
